export type WebCodecsExecutionMode = 'worker' | 'main-thread';

/**
 * iOS WebKit exposes WebCodecs on the page while its worker canvas/decoder surface varies by
 * release and device. Keep decoding in-browser on the page there; other engines retain the
 * dedicated worker path.
 */
export function selectWebCodecsExecutionMode(userAgent: string): WebCodecsExecutionMode {
  const webKit = /AppleWebKit/i.test(userAgent);
  const mobileApple = /(?:iPhone|iPad|iPod|Mobile\/\S+)/i.test(userAgent);
  return webKit && mobileApple ? 'main-thread' : 'worker';
}
